<template>
  <div class="pricing-card" :class="{ 'popular': item.extra }">
    <div v-if="item.extra" class="popular-badge">{{ item.extra }}</div>
    <div class="card-content">
      <div class="plan-header">
        <h3 class="plan-name">{{ item.name }}</h3>
        <div class="price-container">
          <span class="price-currency">{{ item.price }}</span>
          <span class="price-period">{{ item.periode }}</span>
        </div>
      </div>

      <div class="features-list">
        <div v-for="(feature, index) in item.descriptions" :key="index" class="feature-item">
          <div class="feature-icon">
            <VueIcon height="18px" color="#954ce9" icon="mdi:check-circle" />
          </div>
          <span class="feature-text">{{ feature }}</span>
        </div>
      </div>

      <button class="subscribe-button" :class="{ 'popular-button': item.extra }">
        {{ item.buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.pricing-card {
  position: relative;
  width: 300px;
  min-height: 500px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 2rem;
  color: white;
  transition: all 0.3s ease;
  overflow: hidden;
}

.pricing-card:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  border-color: rgba(149, 76, 233, 0.5);
}

.pricing-card.popular {
  background: rgba(149, 76, 233, 0.1);
  border: 1px solid rgba(149, 76, 233, 0.3);
}

.popular-badge {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: linear-gradient(135deg, #954ce9 0%, #7d32d2 100%);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  color: white;
  box-shadow: 0 4px 15px rgba(149, 76, 233, 0.3);
}

.card-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.plan-header {
  margin-bottom: 2rem;
}

.plan-name {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #fff 0%, #a1a1a1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.price-container {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.price-currency {
  font-size: 2.5rem;
  font-weight: 700;
  color: white;
}

.price-period {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.7);
}

.features-list {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 2rem 0;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.feature-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: rgba(149, 76, 233, 0.1);
  border-radius: 50%;
}

.feature-text {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.4;
}

.subscribe-button {
  width: 100%;
  padding: 1rem;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: white;
  background: linear-gradient(135deg, #954ce9 0%, #7d32d2 100%);
  cursor: pointer;
  transition: all 0.3s ease;
}

.subscribe-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(149, 76, 233, 0.4);
}

.popular-button {
  background: linear-gradient(135deg, #7d32d2 0%, #5b28f3 100%);
}

@media screen and (max-width: 576px) {
  .pricing-card {
    width: 100%;
    max-width: 350px;
    margin: 0 auto;
  }
}
</style>
